export default __webpack_public_path__ + "static/media/logo192x192.3a2cf45c.png";